import { render, staticRenderFns } from "./examinerManage_addAndedit.vue?vue&type=template&id=4b51ac2a&scoped=true"
import script from "./examinerManage_addAndedit.vue?vue&type=script&lang=js"
export * from "./examinerManage_addAndedit.vue?vue&type=script&lang=js"
import style0 from "./examinerManage_addAndedit.vue?vue&type=style&index=0&id=4b51ac2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51ac2a",
  null
  
)

export default component.exports